import { useQuery } from '@tanstack/react-query';
import DOMPurify from 'dompurify';
import { api } from '../../lib/useEntity';
import { ETIQUETA_FOTO_PROVEEDOR, MARCA_FICHA_PROVEEDOR } from '../../../shared/heredado-proveedor';

/**
 * Lo que la ficha enseña del producto de proveedor asociado mientras el
 * producto no tiene foto o descripción propias (shared/heredado-proveedor.ts).
 * Siempre etiquetado: «Foto Proveedor» sobre la imagen y la marca de ficha de
 * proveedor encima del texto. Datos: GET /productos/:id/heredado-proveedor.
 */

export type HeredadoProveedor = {
  producto_proveedor: { id: string; ref_proveedor: string; nombre: string; proveedor_nombre: string | null } | null;
  fotos: { id: string; url: string; nombre: string | null }[];
  descripcion: string | null;
};

export function useHeredadoProveedor(productoId: string, enabled = true) {
  return useQuery({
    queryKey: ['producto', productoId, 'heredado-proveedor'],
    queryFn: () => api.get<HeredadoProveedor>(`/productos/${productoId}/heredado-proveedor`),
    enabled,
    staleTime: 30 * 60_000,
  });
}

export function EtiquetaFotoProveedor({ className = '' }: { className?: string }) {
  return (
    <span className={`pointer-events-none rounded bg-amber-500/90 px-1.5 py-0.5 text-[10px] font-semibold uppercase tracking-wide text-white shadow-sm ${className}`}>
      {ETIQUETA_FOTO_PROVEEDOR}
    </span>
  );
}

export function DescripcionProveedor({ texto, origen, className = '' }: { texto: string; origen?: string | null; className?: string }) {
  return (
    <div className={className}>
      <div className="text-xs font-semibold tracking-wide text-amber-700" title={origen ? `Heredada de ${origen} hasta que el producto tenga su propia descripción` : 'Heredada del producto de proveedor hasta que el producto tenga su propia descripción'}>
        {MARCA_FICHA_PROVEEDOR}
      </div>
      {/<\/?[a-z][^>]*>/i.test(texto)
        ? <div className="prose prose-sm max-w-none text-sm text-slate-600" dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(texto) }} />
        : <p className="whitespace-pre-line text-sm text-slate-600">{texto}</p>}
    </div>
  );
}
